
import api from "@/services/api";

const reportOverdueService = {
  getOverdue(params) {
    return api.get('/report-overdue', { params });
  },

  exportExcel(params) {
    return api.get('/report-overdue/export-excel', {
      params,
      responseType: 'blob',
    });
  },

  exportPDF(params) {
    return api.get('/report-overdue/export-pdf', {
      params,
      responseType: 'blob',
    });
  },
};

export default reportOverdueService;
